export default {
  data: [
    {
      title: 'Xây dựng',
      page: [
        { name: 'Quản lý an toàn lao động', link: '/vi/enterprise/construction/safety' },
        { name: 'Theo dõi và quản lý vật liệu xây dựng', link: '/vi/enterprise/construction/asset' },
        { name: 'Quản lý thiết bị hạng nặng', link: '/vi/enterprise/construction/equipment' },
      ],
    },
    {
      title: 'Logistics',
      page: [
        { name: 'Theo dõi và quản lý vị trí tồn kho', link: '/vi/enterprise/logistics/asset' },
        { name: 'Quản lý an toàn nhân viên kho', link: '/vi/enterprise/logistics/safety' },
      ],
    },
    {
      title: 'Văn phòng',
      page: [{ name: 'Quản lý tài sản', link: '/vi/enterprise/office/asset' }],
    },
    {
      title: 'Bệnh viện',
      page: [
        { name: 'Theo dõi vị trí bệnh nhân', link: '/vi/enterprise/medical/patient' },
        { name: 'Quản lý rác thải y tế và tài sản', link: '/vi/enterprise/medical/waste' },
      ],
    },
    {
      title: 'Sản xuất',
      page: [
        { name: 'Quản lý quy trình theo thời gian thực', link: '/vi/enterprise/manufacturing/process' },
        { name: 'Quản lý kho hàng theo thời gian thực', link: '/vi/enterprise/manufacturing/asset' },
      ],
    },
    {
      title: 'Bán lẻ',
      page: [{ name: 'Phân tích khách tham quan triển lãm', link: '/vi/enterprise/retail/exhibition' }],
    },
    {
      title: 'Tải xuống',
      page: [
        { name: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996', backLink: '1' },
        { name: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile', backLink: '1' },
      ],
    },
    {
      title: 'Hỗ trợ',
      page: [
        { name: 'Công nghệ', link: '/vi/enterprise/technology/uwb' },
        { name: 'Blog', link: '/vi/blog' },
        { name: 'Liên hệ kinh doanh', link: '/vi/request' },
        { name: 'Giới thiệu công ty', link: '/vi/company' },
      ],
    },
    {
      title: 'Đối tác',
      page: [
        { name: 'Trang chủ ORBRO', link: '/vi/' },
        { name: 'KongCheck', link: 'https://check.kong-tech.com/', backLink: '1' },
        { name: 'Plutocon', link: 'https://plutocon.io/', backLink: '1' },
      ],
    },
    {
      title: 'Trung tâm CSKH',
      page: [{ name: 'Điện thoại: 1522 - 9928' }, { name: 'Email: pr@orbro.io' }],
    },
  ],
};
